import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { Error } from '@cordata/buffet';

import { useSessionTimeout } from '../utils/session-timeout';

const SessionTimeout = () => {
  const { setIsOpen } = useSessionTimeout();

  useEffect(() => {
    setIsOpen(false);

    localStorage.clear();
  }, []);

  return (
    <div className="text-center">
      <Helmet title="Session Timeout" />

      <Error message="Your session has timed out." />

      <p className="font-size-small text-muted">Any action you take will take you back to the login screen.</p>

      <p className="font-size-small">
        <a href="/login">Go to Login</a>
      </p>
    </div>
  );
};

export default SessionTimeout;
